"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComputerCell = function ComputerCell(props) {
	return _react2.default.createElement(
		_SvgIcon2.default,
		(0, _extends3.default)({ viewBox: "0 0 512 512", className: "custom-icon" }, props),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "97.688,329.143 92.369,356.739 121.804,356.739 125.21,329.143 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "156.808,329.143 153.391,356.739 182.596,356.739 182.596,329.143 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("rect", { x: "213.943", y: "329.143", width: "27.951", height: "27.596" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "299.269,329.143 273.241,329.143 273.241,356.739 300.983,356.739 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "358.724,329.143 330.679,329.143 332.382,356.739 361.89,356.739 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "417.823,329.143 390.269,329.143 393.435,356.739 422.766,356.739 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "87.771,380.594 82.547,407.677 115.503,407.677 118.857,380.594 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "302.456,380.594 150.444,380.594 147.09,407.677 304.128,407.677 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "364.628,380.594 333.866,380.594 335.538,407.677 367.731,407.677 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("polygon", { points: "427.029,380.594 396.173,380.594 399.276,407.677 431.877,407.677 \t\t" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M464.645,292.331V0H47.355v292.331L6.792,449.421V512h498.416v-62.579L464.645,292.331z M78.702,31.347h354.597v247.306 H78.702V31.347z M75.17,310h361.66l31.253,121.041H43.917L75.17,310z M473.861,480.653H38.139v-18.265h435.722V480.653z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("path", { d: "M295.685,131.584c5.475-7.899,8.694-17.471,8.694-27.794c0-26.958-21.943-48.891-48.901-48.891 s-48.901,21.932-48.901,48.891c0,10.324,3.218,19.895,8.694,27.794c-6.572,9.519-20.281,32.956-20.146,62.725 c0,1.139,0.031,2.278,0.073,3.427l0.606,15.047h119.348l0.606-15.047c0.042-1.149,0.073-2.288,0.073-3.427 C315.967,164.54,302.258,141.103,295.685,131.584z M255.478,86.246c9.676,0,17.554,7.868,17.554,17.544 c0,9.686-7.878,17.554-17.554,17.554c-9.676,0-17.554-7.868-17.554-17.554C237.923,94.114,245.802,86.246,255.478,86.246z M227.631,181.436c2.664-14.42,9.237-25.767,12.81-31.117c4.744,1.536,9.791,2.372,15.036,2.372 c5.245,0,10.303-0.836,15.047-2.372c3.542,5.308,10.135,16.677,12.8,31.117H227.631z" })
			)
		),
		_react2.default.createElement(
			"g",
			null,
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement("rect", { x: "194.612", y: "223.608", width: "121.731", height: "31.347" })
			)
		),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null),
		_react2.default.createElement("g", null)
	);
};

exports.default = ComputerCell;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/computercell.js
// module id = 1877
// module chunks = 1143